import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { Component } from 'react';
import MuiUtil from '@/util/MuiUtil';

class IconeAdvogadoPreferencia extends Component {
    static titlePadrao = 'Pedido de preferência';
    static corPadrao = 'black';
    static opacidadePadrao = '1';
    removerTooltip = false;
    removerEstiloPadrao = false;

    static get sxPadrao() {
        return {
            color: IconeAdvogadoPreferencia.corPadrao,
            fill: IconeAdvogadoPreferencia.corPadrao,
            fillOpacity: IconeAdvogadoPreferencia.opacidadePadrao
        };
    }

    constructor(props) {
        super(props);

        let { removerEstiloPadrao, removerTooltip, title, ...propsIcone } = this.props;

        // Carrega as propriedades do tooltip
        this.removerTooltip = removerTooltip !== undefined ? removerTooltip : this.removerTooltip;
        this.title = title !== undefined ? title : IconeAdvogadoPreferencia.titlePadrao;

        // Carrega as propriedades do ícone
        this.removerEstiloPadrao = removerEstiloPadrao !== undefined ? removerEstiloPadrao : this.removerEstiloPadrao;

        if (this.removerEstiloPadrao) {
            this.propsIcone = propsIcone;
        } else {
            this.propsIcone = MuiUtil.mesclarSxStyle(propsIcone);
            this.adicionarSxPadrao();
        }
    }

    /**
     * @desc Adiciona as propriedades padrão sem sobrescrever as existentes.
     */
    adicionarSxPadrao() {
        if (!Object.prototype.hasOwnProperty.call(this.propsIcone, 'sx')) {
            this.propsIcone.sx = IconeAdvogadoPreferencia.sxPadrao;
        } else {
            this.propsIcone.sx = { ...IconeAdvogadoPreferencia.sxPadrao, ...this.propsIcone.sx };
        }
    }

    render() {
        if (this.removerTooltip) {
            return <EmojiPeopleIcon {...this.propsIcone} />;
        } else {
            return (
                <Tooltip title={this.title}>
                    <EmojiPeopleIcon {...this.propsIcone} />
                </Tooltip>
            );
        }
    }
}

IconeAdvogadoPreferencia.propTypes = {
    removerEstiloPadrao: PropTypes.bool,
    removerTooltip: PropTypes.bool,
    title: PropTypes.node
};

export default IconeAdvogadoPreferencia;
